"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function HundredPercent(props) {
  return _react2["default"].createElement(
    "svg",
    { className: props.className, width: props.size, height: props.size, viewBox: "0 0 64 64" },
    _react2["default"].createElement(
      "clipPath",
      { id: "qd" },
      _react2["default"].createElement("path", { d: "M0 7.62h64v48.76H0z" })
    ),
    _react2["default"].createElement(
      "g",
      { clipPath: "url(#qd)" },
      _react2["default"].createElement(
        "clipPath",
        { id: "qf" },
        _react2["default"].createElement("path", { d: "M45.5 44.19c-4.216 7.287-12.095 12.19-21.12 12.19C10.917 56.38 0 45.465 0 32S10.916 7.62 24.38 7.62c9.025 0 16.905 4.902 21.12 12.19h-3.61c-3.855-5.528-10.26-9.144-17.51-9.144C12.6 10.666 3.048 20.218 3.048 32s9.55 21.333 21.333 21.333c7.25 0 13.655-3.616 17.51-9.143h3.61z" })
      ),
      _react2["default"].createElement(
        "g",
        { clipPath: "url(#qf)" },
        _react2["default"].createElement(
          "clipPath",
          { id: "qh" },
          _react2["default"].createElement("path", { d: "M0 7.62h64v48.76H0z" })
        ),
        _react2["default"].createElement("path", { clipPath: "url(#qh)", fill: "#1DC11D", d: "M-15.238-7.62h75.976v79.24h-75.976z" })
      )
    ),
    _react2["default"].createElement(
      "g",
      { clipPath: "url(#qd)" },
      _react2["default"].createElement(
        "clipPath",
        { id: "qj" },
        _react2["default"].createElement("path", { d: "M0 7.62h64v48.76H0z" })
      ),
      _react2["default"].createElement(
        "g",
        { clipPath: "url(#qj)" },
        _react2["default"].createElement(
          "text",
          { transform: "translate(6.097 41.144)", fill: "#0EC826", fontFamily: "'Roboto-Regular'", fontSize: "24.381" },
          "100%"
        )
      ),
      _react2["default"].createElement(
        "g",
        { clipPath: "url(#qj)" },
        _react2["default"].createElement(
          "text",
          { transform: "translate(6.097 41.144)", fill: "#0EC826", fontFamily: "'Roboto-Regular'", fontSize: "24.381" },
          "100%"
        )
      )
    )
  );
}

exports["default"] = HundredPercent;
module.exports = exports["default"];